import script from "./WriteAboutUsBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./WriteAboutUsBanner.vue?vue&type=script&setup=true&lang=ts"

import "./WriteAboutUsBanner.vue?vue&type=style&index=0&id=939a3dc0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-939a3dc0"]])

export default __exports__